export default __webpack_public_path__ + "static/media/Db_9.ffd84fed.png";